export default {
  prePayment: 1,
  postPayment: 2,
};
